import React, { useState, useRef, useEffect } from 'react';

const App = ({ currentDate }) => {

    const Ref = useRef(null);
    const [timer, setTimer] = useState('00:00');
    const getTimeRemaining = (e) => {
        const total = Date.parse(e) - Date.parse(new Date());
        const seconds = Math.floor((total / 1000) % 60);
        const minutes = Math.floor((total / 1000 / 60) % 60);
        return {
            total,
            minutes,
            seconds,
        };
    };

    const startTimer = (e) => {
        let { total, minutes, seconds } = getTimeRemaining(e);
        if (total >= 0) {
            setTimer(
                (minutes > 9 ? minutes : '0' + minutes) +
                ':' +
                (seconds > 9 ? seconds : '0' + seconds)
            );
        }
    };

    const clearTimer = (e) => {
        setTimer('30:00');
        if (Ref.current) clearInterval(Ref.current);
        const id = setInterval(() => {
            startTimer(e);
        }, 1000);
        Ref.current = id;
    };

    const getDeadTime = () => {
        let deadline = new Date(currentDate);
        deadline.setSeconds(deadline.getSeconds() + 1800);
        return deadline;

    };

    useEffect(() => {
        clearTimer(getDeadTime());
    }, []);

    return (
        <div>
            <p>{timer == "30:00" ? "Harap Segera Di Konfirmasi" : timer}</p>
        </div>
    );
};

export default App;
